import { Typography } from '@mui/material';

const Profile = () => {
  return <Typography paragraph>Profile Page</Typography>;
};

export default Profile;
